<ng-container *transloco="let t; read: 'analysis-details'">
  <div class="xi-modal__container analysis-details__container">
    <h2 class="xi-modal__title">{{ t('title') }}</h2>

    <div class="xi-modal__content analysis-details__content">
      <div class="full-width analysis-details__collection-name-input-container">
        <div class="analysis-details__collection-name-input">
          <xi-input-field
            [label]="t('collection-name')"
            [placeholder]="t('enter-here')"
            [(ngModel)]="displayName"
            name="displayName"
            required
            [status]="collectionNameStatus"
            (onChange)="onValidateCollectionName()"
            [stretch]="true"
            [disabled]="collection.data.locked"
          ></xi-input-field>
        </div>

        @if (!isReadOnly) {
          <div class="xi-loader-button-container">
            <xi-default-button
              [text]="t('save')"
              [disabled]="collectionNameHasErrors() || collection.data.locked"
              [tooltip]="collection.data.locked ? { text: t('collection-locked') } : undefined"
              [tooltipDisplayOnDisabled]="true"
              (onClick)="saveCollectionName()"
            ></xi-default-button>
            @if (isSaving) {
              <div class="xi-loader-container__inline-overlay">
                <xi-animation
                  [height]="75"
                  [width]="75"
                  [loop]="true"
                  animation="cx_loader"
                ></xi-animation>
              </div>
            }
          </div>
        }
      </div>

      @if (showDriverAnalysis) {
        <div class="analysis-details-table__container">
          <div class="xi-table__header">
            <h3 class="analysis-details__table-title">{{ t('title-kda') }}</h3>
          </div>
          <div class="analysis-details__driver-analysis-table-scrollbar">
            <table mat-table [dataSource]="driverAnalysisDs" class="xi-table__table">
              <ng-container matColumnDef="displayName">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="xi-table__table-header-content">
                    <div class="xi-table__table-header-border"></div>
                    <span>{{ t('name') }}</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" class="analysis-details__table_cell_name">
                  <div [matTooltip]="element.displayName || '-'">
                    <ng-container *appMiddleEllipsize="element.displayName || '-'"></ng-container>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="analysisDate">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="xi-table__table-header-content">
                    <div class="xi-table__table-header-border"></div>
                    <span>{{ t('analysis-date') }}</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.finishedAt | lexDate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="dependent">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="xi-table__table-header-content">
                    <div class="xi-table__table-header-border"></div>
                    <span>{{ t('dependent') }}</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <span [class.ellipsis-loader]="!element.dependentLabel">{{
                    element.dependentLabel
                  }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="drivers">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="xi-table__table-header-content">
                    <div class="xi-table__table-header-border"></div>
                    <span>{{ t('drivers') }}</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div
                    [matTooltip]="element.driversTooltip"
                    matTooltipClass="analysis-details__left-align-tooltip-text"
                  >
                    <xi-icon icon="app_seo"></xi-icon>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="breakdown">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="xi-table__table-header-content">
                    <div class="xi-table__table-header-border"></div>
                    <span>{{ t('hierarchy') }}</span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div
                    [matTooltip]="element.hierarchyTooltip"
                    matTooltipClass="analysis-details__left-align-tooltip-text"
                  >
                    <xi-icon icon="app_seo"></xi-icon>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="xi-table__table-header-content">
                    <div class="xi-table__table-header-border"></div>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (!isReadOnly) {
                    <div class="analysis-details__action-icons-container">
                      <xi-icon-button
                        color="orca"
                        (onClick)="deleteDriverAnalysis(element)"
                        icon="trash"
                        [hasAnimation]="true"
                        buttonSize="small"
                        [tooltip]="{
                          text: t('delete-kda'),
                          direction: 6,
                        }"
                        [disabled]="collection.data.locked"
                      >
                      </xi-icon-button>
                    </div>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="driverAnalysisColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: driverAnalysisColumns"></tr>
            </table>
          </div>
        </div>
      }

      <div class="analysis-details-table__container">
        <div class="xi-table__header">
          <h3 class="analysis-details__table-title">{{ t('title-nlp') }}</h3>
        </div>

        <div
          [ngClass]="
            showDriverAnalysis
              ? 'analysis-details__nlp-table-scrollbar--small'
              : 'analysis-details__nlp-table-scrollbar--normal'
          "
        >
          <table
            mat-table
            [dataSource]="analysisDs"
            matSort
            matSortDisableClear
            [matSortActive]="sort.active"
            [matSortDirection]="sort.direction"
            (matSortChange)="onAnalysisDetailsTableSortChanged($event)"
            class="xi-table__table"
          >
            <ng-container matColumnDef="displayName">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="xi-table__header-sort-container"
              >
                <div class="xi-table__table-header-content">
                  <div class="xi-table__table-header-border"></div>

                  <span>{{ t('name') }}</span>
                </div>
              </th>

              <td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
            </ng-container>

            <ng-container matColumnDef="analysisDate">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="xi-table__header-sort-container"
              >
                <div class="xi-table__table-header-content">
                  <div class="xi-table__table-header-border"></div>

                  <span>{{ t('analysis-date') }}</span>
                </div>
              </th>

              <td mat-cell *matCellDef="let element">
                {{ element.lastRunAt || element.modifiedAt | lexDate }}
              </td>
            </ng-container>

            <ng-container matColumnDef="configName">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="xi-table__header-sort-container"
              >
                <div class="xi-table__table-header-content">
                  <div class="xi-table__table-header-border"></div>

                  <span>{{ t('configuration') }}</span>
                </div>
              </th>

              <td mat-cell *matCellDef="let element">
                {{
                  configurationService.getConfigName(
                    configurations,
                    element.configName,
                    element.configId
                  )
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                <div class="xi-table__table-header-content">
                  <div class="xi-table__table-header-border"></div>
                </div>
              </th>

              <td mat-cell *matCellDef="let element">
                <div class="analysis-details__action-icons-container">
                  @if (element.notes) {
                    <div>
                      <xi-icon-button
                        color="orca"
                        icon="notepad"
                        [hasAnimation]="false"
                        [tooltip]="{ text: element.notes, direction: 12 }"
                      ></xi-icon-button>
                    </div>
                  }
                  @if (showEditAnalysis(element)) {
                    <div>
                      <xi-icon-button
                        color="orca"
                        (onClick)="editAnalysis(element)"
                        icon="edit"
                        buttonSize="small"
                        [hasAnimation]="true"
                        [tooltip]="{
                          text: t('change-analysis-properties'),
                          direction: 3,
                        }"
                        [disabled]="collection.data.locked"
                      >
                      </xi-icon-button>
                    </div>
                  }
                  @if (showProgressSpinner(element)) {
                    <div [ngClass]="['indicator-icon', element.status]">
                      <mat-progress-spinner
                        mode="determinate"
                        [value]="100 * element.progress"
                        diameter="24"
                        strokeWidth="2"
                        class="orange"
                      ></mat-progress-spinner>
                      @if (showRequeueButton(element)) {
                        <div class="analysis-details__requeue-analysis-button">
                          <xi-icon-button
                            color="orca"
                            [disabled]="collection.data.isAutoAnalyze || collection.data.locked"
                            (onClick)="requeueAnalysis(element)"
                            icon="refresh"
                            [hasAnimation]="true"
                            buttonSize="small"
                            [tooltip]="{ text: t('requeue-analysis'), direction: 6 }"
                          >
                          </xi-icon-button>
                        </div>
                      }
                    </div>
                  }
                  @if (showProgressSpinner(element)) {
                    <span class="progress-value"
                      >{{ 100 * element.progress | number: '1.0-0' }}%</span
                    >
                  }
                  @if (showDownloadAnalysisExcelReport(element)) {
                    @if (collection.data.locked) {
                      <ng-container
                        *ngTemplateOutlet="excelBtnTemplate; context: { $implicit: true }"
                      ></ng-container>
                    } @else {
                      <div [matMenuTriggerFor]="excelDownloadMenuTrigger">
                        <ng-container *ngTemplateOutlet="excelBtnTemplate"></ng-container>
                      </div>
                    }
                    <ng-template #excelBtnTemplate let-isDisabled>
                      <xi-icon-button
                        color="orca"
                        (onClick)="selectedAnalysis = element"
                        icon="document_ext_excel"
                        buttonSize="small"
                        [hasAnimation]="true"
                        [tooltip]="{
                          text: t('download-excel-report'),
                          direction: 3,
                        }"
                        [disabled]="isDisabled"
                      ></xi-icon-button>
                    </ng-template>
                  }
                  @if (showAnalysisError(element)) {
                    <div>
                      <xi-icon-button
                        color="error"
                        icon="warning"
                        [tooltip]="{
                          text: t('copy-status-text', { statusText: element.statusText }),
                          direction: 6,
                        }"
                        (onClick)="copyAnalysisError(element)"
                      ></xi-icon-button>
                    </div>
                  }
                  @if (showDeleteAnalysis(element)) {
                    <div>
                      <xi-icon-button
                        color="orca"
                        [disabled]="collection.data.isAutoAnalyze || collection.data.locked"
                        (onClick)="deleteAnalysis(element)"
                        icon="trash"
                        [hasAnimation]="true"
                        buttonSize="small"
                        [tooltip]="{ text: t('delete-analysis'), direction: 6 }"
                      ></xi-icon-button>
                    </div>
                  }
                  @if (showDeleteAnalysis(element)) {
                    <div>
                      <xi-icon-button
                        color="orca"
                        [disabled]="
                          collection.data.locked ||
                          collection.data.isAutoAnalyze ||
                          !!collection.activeAnalysis
                        "
                        (onClick)="reAnalyzeAnalaysis(element)"
                        icon="copy"
                        [hasAnimation]="true"
                        buttonSize="small"
                        [tooltip]="
                          collection.data.isAutoAnalyze
                            ? {
                                text: t('cannot-reanalyze-autoanalysis'),
                                direction: 6,
                              }
                            : collection.activeAnalysis
                              ? {
                                  text: t('cannot-reanalyze-ongoing'),
                                  direction: 6,
                                }
                              : { text: t('reanalyze'), direction: 6 }
                        "
                      ></xi-icon-button>
                    </div>
                  }
                  @if (showStopReanalyze(element)) {
                    <div>
                      <xi-icon-button
                        color="orca"
                        [disabled]="collection.data.locked"
                        (onClick)="stopReAnalyze(element)"
                        icon="cancel"
                        [hasAnimation]="true"
                        buttonSize="small"
                        [tooltip]="{ text: t('stop-reanalysis'), direction: 6 }"
                      ></xi-icon-button>
                    </div>
                  }
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="analysisColumns; sticky: true"></tr>

            <tr
              mat-row
              *matRowDef="let row; columns: analysisColumns"
              [class.analysis-details__table-row--error]="showAnalysisError(row)"
            ></tr>
          </table>
        </div>
      </div>
    </div>

    <div class="xi-modal__actions analysis-details__action">
      @if (!isReadOnly) {
        <div>
          <xi-default-button
            [text]="t('analyze-data')"
            [disabled]="!canCreateNewAnalysis()"
            [tooltip]="collection.data.locked ? { text: t('no-manual-analysis') } : undefined"
            [tooltipDisplayOnDisabled]="true"
            (onClick)="createNewAnalysis()"
          ></xi-default-button>
        </div>
      }
    </div>
  </div>

  <mat-menu #excelDownloadMenuTrigger>
    <div mat-menu-item disabled class="mat-menu-header">{{ t('create-report') }}</div>

    <button
      mat-menu-item
      (click)="downloadAnalysisExcelReport(selectedAnalysis, 'DOCUMENT_DETAILS_REPORT', 'Docs')"
    >
      <div>{{ t('document-details') }}</div>
    </button>

    <div [matTooltip]="!canExportQueryTopicsReport ? t('no-query-topics') : undefined">
      <button
        mat-menu-item
        (click)="
          downloadAnalysisExcelReport(selectedAnalysis, 'QUERY_DETAILS_REPORT', 'Query Topics')
        "
        [disabled]="!canExportQueryTopicsReport"
      >
        <div>{{ t('query-topics') }}</div>
      </button>
    </div>

    <div [matTooltip]="!canExportConceptTopicsReport ? t('no-concept-topics') : undefined">
      <button
        mat-menu-item
        (click)="
          downloadAnalysisExcelReport(selectedAnalysis, 'CONCEPT_DETAILS_REPORT', 'Concept Topics')
        "
        [disabled]="!canExportConceptTopicsReport"
      >
        <div>{{ t('concept-topics') }}</div>
      </button>
    </div>

    <div [matTooltip]="!canExportThemesReport ? t('no-themes') : undefined">
      <button
        mat-menu-item
        (click)="downloadAnalysisExcelReport(selectedAnalysis, 'THEME_DETAILS_REPORT', 'Themes')"
        [disabled]="!canExportThemesReport"
      >
        <div>{{ t('themes') }}</div>
      </button>
    </div>

    <div [matTooltip]="!canExportEntitiesReport ? t('no-entities') : undefined">
      <button
        mat-menu-item
        (click)="downloadAnalysisExcelReport(selectedAnalysis, 'ENTITY_DETAILS_REPORT', 'Entities')"
        [disabled]="!canExportEntitiesReport"
      >
        <div>{{ t('entities') }}</div>
      </button>
    </div>

    <div [matTooltip]="!canExportEntitiesReport ? t('no-entities') : undefined">
      <button
        mat-menu-item
        (click)="
          downloadAnalysisExcelReport(
            selectedAnalysis,
            'ENTITY_THEME_DETAILS_REPORT',
            'Entity Themes'
          )
        "
        [disabled]="!canExportEntitiesReport"
      >
        <div>{{ t('entity-themes') }}</div>
      </button>
    </div>

    <div [matTooltip]="!canExportTaxonomyReport ? '' : undefined">
      <button
        mat-menu-item
        (click)="
          downloadAnalysisExcelReport(selectedAnalysis, 'TAXONOMY_DETAILS_REPORT', 'Taxonomy')
        "
        [disabled]="!canExportTaxonomyReport"
      >
        <div>{{ t('taxonomy') }}</div>
      </button>
    </div>
  </mat-menu>
</ng-container>
